/**
 * modal.js — mở/đóng modal thành công sau khi gửi form.
 *
 * CSS đã mở modal bằng :target nên modal chạy được cả khi JS lỗi; file này chỉ
 * nâng cấp trải nghiệm: khoá cuộn nền, đưa focus vào panel, giữ focus trong panel,
 * Esc để đóng và trả focus về chỗ cũ.
 *
 * Nút đóng là thẻ <a> chứ không phải <button> nên danh sách focus phải tính cả <a>.
 * Ngoài .modal__close / .modal__overlay, phần tử nào có [data-modal-close] cũng đóng modal (nút "Để sau"
 * của popup khuyến mãi). Mở / đóng bắn sự kiện modal:open / modal:close (bubbles) trên chính .modal để
 * module khác bám theo mà không phải sửa file này (js/promo-popup.js).
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
    var openModal = null;
    var lastFocus = null;

    function panelOf(modal) {
        return modal.querySelector('.modal__panel');
    }

    function emit(modal, name) {
        var event;
        try {
            event = new CustomEvent(name, { bubbles: true });
        } catch (e) {
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(name, true, false, null);
        }
        modal.dispatchEvent(event);
    }

    function open(modal) {
        if (!modal || openModal === modal) return;

        openModal = modal;
        lastFocus = document.activeElement;

        modal.classList.remove('is-dismissed');
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';

        var panel = panelOf(modal);
        if (panel) {
            if (!panel.hasAttribute('tabindex')) panel.setAttribute('tabindex', '-1');
            panel.focus();
        }
        emit(modal, 'modal:open');
    }

    function close() {
        if (!openModal) return;

        var modal = openModal;
        modal.classList.remove('is-open');
        // replaceState xoá hash trên URL nhưng Chrome KHÔNG tính lại :target, nên modal mở
        // bằng #hash vẫn khớp .modal:target và không đóng được. Không gán location.hash = ''
        // vì trang sẽ nhảy lên đầu — thay vào đó gắn .is-dismissed để CSS ép ẩn.
        modal.classList.add('is-dismissed');
        openModal = null;
        document.body.style.overflow = '';

        // Xoá hash để F5 không mở lại modal, nhưng giữ nguyên lịch sử. Chỉ xoá khi hash là
        // của chính modal này — modal mở bằng JS (popup khuyến mãi) không được nuốt anchor
        // khách đang xem (faqs.html#giao-hang-di-tinh).
        if (window.location.hash === '#' + modal.id && window.history && window.history.replaceState) {
            window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }

        if (lastFocus && lastFocus.focus) lastFocus.focus();
        lastFocus = null;
        emit(modal, 'modal:close');
    }

    function fromHash() {
        var hash = window.location.hash;
        if (!hash || hash.length < 2) return;

        var target = document.getElementById(hash.slice(1));
        if (target && target.classList.contains('modal')) open(target);
    }

    document.addEventListener('click', function (event) {
        var closer = event.target.closest ? event.target.closest('.modal__close, .modal__overlay, [data-modal-close]') : null;

        if (closer && openModal && openModal.contains(closer)) {
            event.preventDefault();
            close();
            return;
        }

        // Nút "Close" trong .modal__actions trỏ href="#"
        var action = event.target.closest ? event.target.closest('.modal__actions a[href="#"]') : null;
        if (action && openModal && openModal.contains(action)) {
            event.preventDefault();
            close();
        }
    });

    document.addEventListener('keydown', function (event) {
        if (!openModal) return;

        if (event.key === 'Escape' || event.key === 'Esc') {
            close();
            return;
        }

        if (event.key !== 'Tab') return;

        var panel = panelOf(openModal);
        if (!panel) return;

        var items = [].slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (el) {
            return el.offsetWidth > 0 || el.offsetHeight > 0;
        });

        if (!items.length) return;

        var first = items[0];
        var last = items[items.length - 1];

        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    });

    window.addEventListener('hashchange', fromHash);
    fromHash();

    // Cho module khác mở / đóng modal mà không phải đổi #hash trên URL (js/advise.js)
    window.WBModal = { open: open, close: close };
})();
